export enum DelegationAddRequestTimezone {
  EUROPE_WARSAW = "Europe/Warsaw",
  UTC = "UTC",
}

export enum DelegationAddRequestVehicleType {
  COMPANY_OWNED = "COMPANY_OWNED",
  CAR_GT_900CM3 = "CAR_GT_900CM3",
  CAR_LE_900CM3 = "CAR_LE_900CM3",
  MOTORCYCLE = "MOTORCYCLE",
  MOPED = "MOPED",
}

export type DelegationAddRequestAddressSequenceNode = {
  lat: number;
  lon: number;
  displayName: string;
  zipCode?: string;
  town?: string;
  street?: string;
  houseNumber?: string;
  apartmentNumber?: string;
  time?: Date;
  distance?: number;
};

export type DelegationAddRequestAddressSequenceNodeGroup = {
  nodes: DelegationAddRequestAddressSequenceNode[];
  vehicleType: DelegationAddRequestVehicleType;
};

export type DelegationAddRequestAddressSequence = {
  seq: DelegationAddRequestAddressSequenceNodeGroup[];
};

export type DelegationAddRequestQueryParams = {
  timezone?: DelegationAddRequestTimezone;
};

export type DelegationAddRequestBody = {
  cargoCompanyId: string;
  workerId: string;
  mileagesCost: number;
  totalDistance: number;
  dateFrom: Date;
  dateTo: Date;
  addressSequence: DelegationAddRequestAddressSequence;
  osrmDistance?: number;
  prepay?: number;
  localTravelCost?: number;
  oneDayDietCost?: number;
  wholeDayDietCost?: number;
  startedDayDietCost?: number;
  accommodationBillsCost?: number;
  accommodationCost?: number;
  otherExpenses?: number;
};

type DelegationAddRequest = {
  workerCompanyUuid: string;
  workerUuid: string;
  mileagesCost: number;
  totalDistance: number;
  dateFrom: Date;
  dateTo: Date;
  addressSequence: DelegationAddRequestAddressSequenceNode[][];
  groupVehicleTypes: DelegationAddRequestVehicleType[];
  osrmDistance?: number;
  prepay?: number;
  localTravelCost?: number;
  oneDayDietCost?: number;
  wholeDayDietCost?: number;
  startedDayDietCost?: number;
  accommodationBillsCost?: number;
  accommodationCost?: number;
  otherExpenses?: number;
  timezone?: DelegationAddRequestTimezone;
};

export default DelegationAddRequest;
